module.exports = __webpack_public_path__ + "img/erp-solution-listing.bc12fdd5.jpg";